import { TypeOf, z } from 'zod';

import { Card } from '@repo/ui/Card';
import { Form } from '@repo/ui/Form';
import { useZodForm } from '@repo/hooks/useZodForm';
import { TextInputField, TextAreaField } from '@repo/ui/Form';
import { Button } from '@repo/ui/Button';

import { gql } from '@apollo/client';

import { useApolloClient } from '@apollo/client/react';
import type { Mercury } from '@repo/types/Models';

const updateApiKeyFormSchema = z.object({
  name: z.string().min(2, { message: 'Api Key name must contain at least 2 characters.' }),
  notes: z.string().optional(),
});

type UpdateApiKeyFormSchema = TypeOf<typeof updateApiKeyFormSchema>;

interface UpdateApiKeyFormProps {
  apiKeyId: Mercury.Models.ApiKey['id'];
  name: Mercury.Models.ApiKey['name'];
  notes?: Mercury.Models.ApiKey['notes'];
  refetch: () => void;
}

const UpdateApiKeyForm = ({ apiKeyId, name, notes, refetch }: UpdateApiKeyFormProps) => {
  const UPDATE_API_KEY = gql`
    mutation UpdateApiKeyAccount($id: ID!, $input: UpdateApiKeyInput!) {
      updateApiKey(id: $id, input: $input) {
        apiKey {
          id
        }
      }
    }
  `;

  const client = useApolloClient();

  const onSubmit = async (input: UpdateApiKeyFormSchema) => {
    await client.mutate({
      mutation: UPDATE_API_KEY,
      variables: {
        id: apiKeyId,
        input,
      },
    });

    refetch();
  };

  const form = useZodForm({
    schema: updateApiKeyFormSchema,
    onSubmit,
  });

  return (
    <>
      <Card>
        <Form {...form}>
          <Form.Success>Api Key successfully updated.</Form.Success>
          <Form.Error>
            Unable to updateApi Key. Please try again later or contact support if error persists.
          </Form.Error>

          <TextInputField id="name" label="Name" defaultValue={name} {...form.register('name')} />
          <TextAreaField
            id="notes"
            label="Description"
            defaultValue={notes}
            {...form.register('notes')}
          />
          <Button type="submit">Update</Button>
        </Form>
      </Card>
    </>
  );
};

export default UpdateApiKeyForm;
